import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-604a385d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cs-container bg-white",
  style: {"width":"680px","min-width":"680px","max-width":"680px"},
  id: "estimate-print"
}
const _hoisted_2 = { class: "noprint w-full mb-5 text-right" }
const _hoisted_3 = { class: "flex mb-3" }
const _hoisted_4 = { class: "inline-block w-1/2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pb-2 border-b",
  style: {"width":"18rem"}
}, [
  /*#__PURE__*/_createElementVNode("h1", { class: "inline-block text-2xl font-bold" }, "임 시 견 적 (ESTIMATION)")
], -1))
const _hoisted_6 = {
  class: "mt-2",
  style: {"width":"18rem"}
}
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block mt-5 text-3xs" }, [
  /*#__PURE__*/_createElementVNode("p", null, "귀사의 일익 번창하심을 기원합니다."),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "문의하신 제품 제작에 대한 예산 내역서를 제출하오니"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "업무 참조 바랍니다.")
], -1))
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-end w-1/2\" data-v-604a385d><div class=\"inline-block mt-9\" style=\"width:17rem;\" data-v-604a385d><p class=\"text-xl font-bold\" data-v-604a385d>하이쓰리디(HY3D)</p><div class=\"mt-5 text-3xs\" data-v-604a385d><p data-v-604a385d>사업자등록번호: 480-81-01029</p><p class=\"mt-1\" data-v-604a385d>업태: 제조업, 서비스업</p><p class=\"mt-1\" data-v-604a385d>소재: 경기도 안산시 상록구 사동 한양대학로 55</p><p class=\"mt-1\" data-v-604a385d>한양대학교 erica캠퍼스 창업보육센터 204호</p><p class=\"mt-1\" data-v-604a385d>연락처: 031-436-8029</p></div><p class=\"mt-2 text-2xs text-right\" data-v-604a385d>대표이사 이정욱</p></div></div>", 1)
const _hoisted_10 = { class: "mt-20" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "mt-8" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "mt-1" }
const _hoisted_15 = { class: "tg tb-1 text-2xs" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "tg-0lax",
      rowspan: "2"
    }, "No"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "tg-0lax",
      rowspan: "2"
    }, "내역"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "tg-0lax",
      colspan: "2"
    }, "단가"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "tg-0lax",
      rowspan: "2"
    }, "금액(원)")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax th-c-q" }, "수량"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax th-c-p-" }, "금액(원)")
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "1", -1))
const _hoisted_18 = { class: "tg-0lax" }
const _hoisted_19 = { class: "tg-0lax" }
const _hoisted_20 = { class: "tg-0lax" }
const _hoisted_21 = {
  class: "tg-0lax",
  rowspan: "10"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "2", -1))
const _hoisted_23 = { class: "tg-0lax" }
const _hoisted_24 = { class: "tg-0lax" }
const _hoisted_25 = { class: "tg-0lax" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "3", -1))
const _hoisted_27 = { class: "tg-0lax" }
const _hoisted_28 = { class: "tg-0lax" }
const _hoisted_29 = { class: "tg-0lax" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "4", -1))
const _hoisted_31 = { class: "tg-0lax" }
const _hoisted_32 = { class: "tg-0lax" }
const _hoisted_33 = { class: "tg-0lax" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "5", -1))
const _hoisted_35 = { class: "tg-0lax" }
const _hoisted_36 = { class: "tg-0lax" }
const _hoisted_37 = { class: "tg-0lax" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "6", -1))
const _hoisted_39 = { class: "tg-0lax" }
const _hoisted_40 = { class: "tg-0lax" }
const _hoisted_41 = { class: "tg-0lax" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "7", -1))
const _hoisted_43 = { class: "tg-0lax" }
const _hoisted_44 = { class: "tg-0lax" }
const _hoisted_45 = { class: "tg-0lax" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "8", -1))
const _hoisted_47 = { class: "tg-0lax" }
const _hoisted_48 = { class: "tg-0lax" }
const _hoisted_49 = { class: "tg-0lax" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "9", -1))
const _hoisted_51 = { class: "tg-0lax" }
const _hoisted_52 = { class: "tg-0lax" }
const _hoisted_53 = { class: "tg-0lax" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "10", -1))
const _hoisted_55 = { class: "tg-0lax" }
const _hoisted_56 = { class: "tg-0lax" }
const _hoisted_57 = { class: "tg-0lax" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "tg-0lax",
  colspan: "4"
}, "소계", -1))
const _hoisted_59 = { class: "tg-0lax" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-8" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "2. 총계")
], -1))
const _hoisted_61 = { class: "mt-1" }
const _hoisted_62 = { class: "tg tb-2 text-2xs" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "No"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "내역"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "출력"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "후처리"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "도색"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "배송"),
    /*#__PURE__*/_createElementVNode("th", { class: "tg-0lax" }, "합계")
  ])
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tg-0lax" }, "1", -1))
const _hoisted_65 = { class: "tg-0lax" }
const _hoisted_66 = { class: "tg-0lax" }
const _hoisted_67 = { class: "tg-0lax" }
const _hoisted_68 = { class: "tg-0lax" }
const _hoisted_69 = { class: "tg-0lax" }
const _hoisted_70 = { class: "tg-0lax" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "tg-0lax",
  colspan: "6"
}, "공급가액", -1))
const _hoisted_72 = { class: "tg-0lax" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "tg-0lax",
  colspan: "6"
}, "V.A.T", -1))
const _hoisted_74 = { class: "tg-0lax" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "tg-0lax",
  colspan: "6"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "최종금액")
], -1))
const _hoisted_76 = { class: "tg-0lax" }
const _hoisted_77 = { class: "font-bold" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"page-break-after":"always"} }, null, -1))
const _hoisted_79 = { class: "mt-5" }
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div class=\"text-2xs\" data-v-604a385d><p data-v-604a385d>1. 대금 지불기준</p><p class=\"mt-1\" data-v-604a385d>: 3D 출력제작 비용 선납</p><div class=\"mt-4 mb-4\" data-v-604a385d></div><p data-v-604a385d>2. 제작기간</p><p class=\"mt-1\" data-v-604a385d>: 상호 합의하에 일정 조정 가능</p><div class=\"mt-4 mb-4\" data-v-604a385d></div><p data-v-604a385d>3. 프린팅 제작</p><p class=\"mt-1\" data-v-604a385d>: 출력 진행시 수정 및 중단이 불가하며, 제작기간 이후의 제품에 대해서 A/S 지원 불가</p><div class=\"mt-4 mb-4\" data-v-604a385d></div><p data-v-604a385d>4. 임시 견적</p><p class=\"mt-1\" data-v-604a385d>: 본 견적은 임시 견적으로 제품에 따라 검토 후 데이터 오류, 추가 작업에 따라 견적 금액이 변경 될 수 있습니다</p></div>", 1)
const _hoisted_81 = { class: "flex justify-end mt-10" }
const _hoisted_82 = { class: "flex justify-between w-60 text-xs font-bold" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "견적일자:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-print",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrint && _ctx.onPrint(...args)))
      }, "출력하기"),
      _createElementVNode("button", {
        class: "btn-print ml-5",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
      }, "뒤로이동")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.estimate.clientCompany), 1)
        ]),
        _hoisted_8
      ]),
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, "□ 합계금액 : ₩ " + _toDisplayString(_ctx.totalCost), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", _hoisted_13, "1. " + _toDisplayString(_ctx.estimate.clientCompany) + " 제작", 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("table", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("td", _hoisted_18, _toDisplayString(0 < _ctx.models.length ? _ctx.models[0].name : ""), 1),
            _createElementVNode("td", _hoisted_19, _toDisplayString(0 < _ctx.models.length ? _ctx.models[0].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_20, _toDisplayString(0 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[0].modelCost * _ctx.models[0].modelCount) : ""), 1),
            _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.numberToComma(_ctx.estimate.modelCost ? _ctx.estimate.modelCost : 0)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_22,
            _createElementVNode("td", _hoisted_23, _toDisplayString(1 < _ctx.models.length ? _ctx.models[1].name : ""), 1),
            _createElementVNode("td", _hoisted_24, _toDisplayString(1 < _ctx.models.length ? _ctx.models[1].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_25, _toDisplayString(1 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[1].modelCost * _ctx.models[1].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_26,
            _createElementVNode("td", _hoisted_27, _toDisplayString(2 < _ctx.models.length ? _ctx.models[2].name : ""), 1),
            _createElementVNode("td", _hoisted_28, _toDisplayString(2 < _ctx.models.length ? _ctx.models[2].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_29, _toDisplayString(2 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[2].modelCost * _ctx.models[2].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_30,
            _createElementVNode("td", _hoisted_31, _toDisplayString(3 < _ctx.models.length ? _ctx.models[3].name : ""), 1),
            _createElementVNode("td", _hoisted_32, _toDisplayString(3 < _ctx.models.length ? _ctx.models[3].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_33, _toDisplayString(3 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[3].modelCost * _ctx.models[3].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_34,
            _createElementVNode("td", _hoisted_35, _toDisplayString(4 < _ctx.models.length ? _ctx.models[4].name : ""), 1),
            _createElementVNode("td", _hoisted_36, _toDisplayString(4 < _ctx.models.length ? _ctx.models[4].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_37, _toDisplayString(4 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[4].modelCost * _ctx.models[4].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_38,
            _createElementVNode("td", _hoisted_39, _toDisplayString(5 < _ctx.models.length ? _ctx.models[5].name : ""), 1),
            _createElementVNode("td", _hoisted_40, _toDisplayString(5 < _ctx.models.length ? _ctx.models[5].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_41, _toDisplayString(5 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[5].modelCost * _ctx.models[5].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_42,
            _createElementVNode("td", _hoisted_43, _toDisplayString(6 < _ctx.models.length ? _ctx.models[6].name : ""), 1),
            _createElementVNode("td", _hoisted_44, _toDisplayString(6 < _ctx.models.length ? _ctx.models[6].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_45, _toDisplayString(6 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[6].modelCost * _ctx.models[6].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_46,
            _createElementVNode("td", _hoisted_47, _toDisplayString(7 < _ctx.models.length ? _ctx.models[7].name : ""), 1),
            _createElementVNode("td", _hoisted_48, _toDisplayString(7 < _ctx.models.length ? _ctx.models[7].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_49, _toDisplayString(7 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[7].modelCost * _ctx.models[7].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_50,
            _createElementVNode("td", _hoisted_51, _toDisplayString(8 < _ctx.models.length ? _ctx.models[8].name : ""), 1),
            _createElementVNode("td", _hoisted_52, _toDisplayString(8 < _ctx.models.length ? _ctx.models[8].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_53, _toDisplayString(8 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[8].modelCost * _ctx.models[8].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_54,
            _createElementVNode("td", _hoisted_55, _toDisplayString(9 < _ctx.models.length ? _ctx.models[9].name : ""), 1),
            _createElementVNode("td", _hoisted_56, _toDisplayString(9 < _ctx.models.length ? _ctx.models[9].modelCount : ""), 1),
            _createElementVNode("td", _hoisted_57, _toDisplayString(9 < _ctx.models.length ? _ctx.numberToComma(_ctx.models[9].modelCost * _ctx.models[9].modelCount) : ""), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_58,
            _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.numberToComma(_ctx.estimate.modelCost ? _ctx.estimate.modelCost : 0)), 1)
          ])
        ])
      ])
    ]),
    _hoisted_60,
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("table", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _hoisted_64,
            _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.estimate.clientCompany), 1),
            _createElementVNode("td", _hoisted_66, _toDisplayString(_ctx.numberToComma(_ctx.estimate.modelCost)), 1),
            _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.numberToComma(_ctx.estimate.postProcessCost)), 1),
            _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.numberToComma(_ctx.estimate.paintCost)), 1),
            _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.numberToComma(_ctx.estimate.shippingCost)), 1),
            _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.supplyPrice), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_71,
            _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.supplyPrice), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_73,
            _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.vat), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_75,
            _createElementVNode("td", _hoisted_76, [
              _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.totalCost), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_78,
    _createElementVNode("div", _hoisted_79, [
      _hoisted_80,
      _createElementVNode("div", _hoisted_81, [
        _createElementVNode("div", _hoisted_82, [
          _hoisted_83,
          _createElementVNode("p", null, _toDisplayString(_ctx.todayDate), 1)
        ])
      ])
    ])
  ]))
}